export const tagTitles = (t) => ({
	mainTitle: t('common.strings.edit_profile'),
	placeholder: t('common.placeholders.enter_profile_name')
})
